import * as React from 'react';
import * as PropTypes from 'prop-types';
import {ButtonProps, ButtonState} from '../types/components';

class Link extends React.Component<ButtonProps, ButtonState> {

    static propTypes = {
        text: PropTypes.string.isRequired,
        onPress: PropTypes.func,
        type: PropTypes.oneOf(['default', 'outlined', 'link', 'small-outlined']),
        disabled: PropTypes.bool,
        customClass: PropTypes.string
    };

    static defaultProps = {
        type: 'default',
        disabled: false,
        customClass: '',
        target: '_self'
    };

    constructor(props) {
        super(props);
        // @ts-ignore
        this.state = {
            buttonStyle: ''
        };
    }

    componentDidMount() {
        this.setStyles(this.props.type);
    }

    setStyles = (type) => {
        switch (type) {
            case 'outlined':
                this.setState({
                    buttonStyle: `btn rounded btn-outline-info ${this.props.customClass} `
                });
                return;
            case 'small-outlined':
                this.setState({
                    buttonStyle: `btn rounded btn-outline-info small button-small-enabled ${this.props.customClass} `
                });
                return;
            case 'link':
                this.setState({
                    buttonStyle: `btn-link ${this.props.customClass} `
                });
                return;
            default:
                this.setState({
                    buttonStyle: `btn rounded btn-info ${this.props.customClass} `
                });
                return;
        }
    }

    render() {
        const {text, onPress, href, target} = this.props;
        const {buttonStyle} = this.state;
        return (
            <a onClick={() => onPress()} className={buttonStyle} href={href} target={target}>
                {text}
            </a>

        );
    }
}

export default Link;